module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-pivotator-utils"
// module id = 10
// module chunks = 0